<div class="container-loader">
  <spinner-bar [diameter]="100"></spinner-bar>
</div>
